import { Modal } from "react-bootstrap";
import { IPopUpProps } from "./Interfaces";

export default function PopUp({
  showPopup,
  setShowPopup,
  popupTitle,
  popupContent,
}: IPopUpProps) {
  return (
    <Modal show={showPopup} onHide={() => setShowPopup(false)}>
      <Modal.Header closeButton>
        <Modal.Title>{popupTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ul>
          {popupContent.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </Modal.Body>
    </Modal>
  );
}
